__turbopack_context__.v({
  "content": "style-module-scss-module__B6I8qG__content",
  "notation": "style-module-scss-module__B6I8qG__notation",
  "subtitle": "style-module-scss-module__B6I8qG__subtitle",
  "title": "style-module-scss-module__B6I8qG__title",
});
